<template>
  <div class="qr-cd-guide-wrapper">
    【要配慮者施設QRコード発行管理手順】
    <div>
      ➀要配慮者施設QRコードを発行するため、「市町村」「地域（地区）」「施設区分」「施設名」「発行単位」を入力し新規登録ボタンを押下します。
    </div>
    <div class="sub-guide">
      （QRコードを登録、発行するための行が追加されます）
    </div>
    <div>
      ②「入力用フォームダウンロード」ボタンから病院、福祉施設に入所している要配慮者もしくは、避難行動要支援者名簿の情報を入力して頂くEXCELシートをダウンロードします。
    </div>
    <div>
      ③ダウンロードしたEXCELシートに病院、福祉施設に入所している要配慮者もしくは、避難行動要支援者名簿の情報を入力します。
    </div>
    <div>
      ④EXCELシートのCSV出力ボタンからアップロード用データをCSV出力します。
    </div>
    <div>
      ⑤「アップロード」ボタンを押下し、④で作成したCSVファイルをサーバにアップロードします。
    </div>
    <div class="sub-guide">
      （病院、福祉施設に入所している要配慮者もしくは、避難行動要支援者名簿の情報を登録します）
    </div>
    <div>
      ⑥QRコード表示欄の「表示」ボタンを押下すると、登録された病院、福祉施設に入所している要配慮者もしくは、避難行動要支援者名簿の情報のQRコードを全てPDFで出力します。
    </div>
    <div class="sub-guide">
      PDFの機能で仮QRコードを印刷します。
    </div>
  </div>
</template>

<script>
export default {
  name: "FacilityQrCodeGuide"
};
</script>
